export const validateContactForm = (formData) => {
  const errors = {};

  // First Name
  if (!formData.first_name.trim()) {
    errors.first_name = "First name is required.";
  } else if (!/^[a-zA-Z\s'-]+$/.test(formData.first_name.trim())) {
    errors.first_name = "First name can only contain letters and spaces.";
  }

  // Last Name
  if (!formData.last_name.trim()) {
    errors.last_name = "Last name is required.";
  } else if (!/^[a-zA-Z\s'-]+$/.test(formData.last_name.trim())) {
    errors.last_name = "Last name can only contain letters and spaces.";
  }

  // Email
  if (!formData.email.trim()) {
    errors.email = "Email is required.";
  } else if (
    !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
  ) {
    errors.email = "Please enter a valid email address.";
  }

  // Phone
  if (!formData.phone.trim()) {
    errors.phone = "Phone number is required.";
} else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
  errors.phone = "Enter a valid 10-digit Indian mobile number";
}


  // Services
  if (!formData.services) {
    errors.services = "Please select a service.";
  }

  // Message (Optional — Add if required)
  // if (!formData.message.trim()) {
  //   errors.message = "Message is required.";
  // }

  return errors;
};
